export default __webpack_public_path__ + "static/media/anonymous-people.0b14e3e5.png";